import { WebApi } from '@/services/WebApi'

const state = () => ({
  schedulePetsCaches: []
})

const getters = {
  findSchedulePetsCaches: (state) => key => state.schedulePetsCaches.find(spc => spc.key === key)
}

const mutations = {
  setLoading (state, { key, loading }) {
    const existing = state.schedulePetsCaches.find(spc => spc.key === key)
    if (existing) {
      existing.loading = !!loading
      existing.retry = false
    } else {
      state.schedulePetsCaches.push({ key: key, values: [], loading: !!loading })
    }
  },
  setPets (state, { key, Pets }) {
    const existing = state.schedulePetsCaches.find(spc => spc.key === key)
    if (existing) {
      existing.values = Pets
      existing.loading = false
    } else {
      state.schedulePetsCaches.push({ key: key, values: Pets, loading: false })
    }
  },
  setRetry (state, key) {
    const existing = state.schedulePetsCaches.find(spc => spc.key === key)
    if (existing) {
      existing.retry = true
      existing.loading = false
    }
  }
}

const actions = {
  fetchSchedulePets ({ commit }, { key, scheduleId, payload }) {
    return new Promise((resolve, reject) => {
      commit('setLoading', { key: key, loading: true })
      WebApi.get('ClientAppointmentSchedule/' + scheduleId + '/Pet?' + new URLSearchParams(payload))
        .then(response => {
          commit('setPets', { key: key, Pets: response.data })
          resolve(response)
        })
        .catch(error => {
          commit('setRetry', key)
          reject(error)
        })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
